import { createFileRoute } from "@tanstack/react-router";
import { RefundsPage } from "@/components/admin/refunds/RefundsPage";

export const Route = createFileRoute("/dashboard/admin/refunds")({
  component: RefundsPage,
});
